import { apiInstances } from '../../../../libs';

const { get } = apiInstances.userInstance;

export const getBankAccountInfoService = async ({ userId, userType }) => {
  return get(`/users/${userId}/${userType}/bank-account`);
};
